import { LINK_SENT, APP_DETAILS } from '../actions/Types';

const initialState = {
  qrCode: '',
  linkSent: false,
  ios: '',
  android: '',
  title: '',
  description: '',
  logo: '',
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LINK_SENT:
      return {
        ...state,
        linkSent: true,
      };
    case APP_DETAILS:
      return {
        ...state,
        qrCode: action.payload.qrCode,
        ios: action.payload.ios,
        android: action.payload.android,
        title: action.payload.title,
        description: action.payload.description,
        logo: action.payload.logo,
      };
    default:
      return state;
  }
};
